exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".score_jl[data-v-3365738a]{padding-top:20px}.score_jl .total[data-v-3365738a]{height:100px;line-height:100px;border:1px solid #d2d2d2;width:90%;margin:0 auto;padding-left:15px;font-size:14px;color:#525250}.score_jl .total span[data-v-3365738a]{font-size:30px}.score_jl .t_table[data-v-3365738a]{width:90%;margin:50px auto}.go-style[data-v-3365738a]{top:32px!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"importLoaders":1,"alias":{"/assets":"/opt/nodeapps/svndata/jzq-web/assets","/static":"/opt/nodeapps/svndata/jzq-web/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3365738a","scoped":true,"hasInlineConfig":true}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./pages/tpl/score.vue
// module id = Wziu
// module chunks = 0 4 5 168